import { render, staticRenderFns } from "./CAMAs.vue?vue&type=template&id=045c6cd7"
import script from "./CAMAs.vue?vue&type=script&lang=js"
export * from "./CAMAs.vue?vue&type=script&lang=js"
import style0 from "./CAMAs.vue?vue&type=style&index=0&id=045c6cd7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports